import useListParkAvailabilityQuery from 'apollo/resolvers/parkAvailability/list';
import { ParkAvailability } from 'apollo/types';
import LoadingModal from 'components/generalUI/LoadingModal';
import React, { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Collapse from 'components/Faq/Collapse';
import useFaqContent from 'components/Faq/useFaqContent';
import styles from './Faq.module.scss';

const Faq = (): ReactElement => {
  const { t } = useTranslation();
  const [parkAvailability, setParkAvailability] = useState<ParkAvailability[]>([]);
  const { data: parkAvailabilityData, loading } = useListParkAvailabilityQuery();
  const content = useFaqContent(parkAvailability);

  const setParkAvailabilityFromQuery = () => {
    if (parkAvailabilityData) {
      setParkAvailability(parkAvailabilityData.listParkAvailability);
    }
  };

  useEffect(() => {
    setParkAvailabilityFromQuery();
  }, [parkAvailabilityData]);

  return (
    <>
      {parkAvailability.length > 0 ? (
        <>
          <h1 className={styles.title}>{t('pages.faq.title')}</h1>
          <Collapse content={content} />
        </>
      ) : (
        <LoadingModal visible={loading} />
      )}
    </>
  );
};

export default Faq;
